import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { useTheme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import * as React from 'react';
import { Images } from '../assets';
import ClaimContainer from './ClaimContainer';
import TextInput from './TextInput';

export interface RecoveryCodeContainerProps {
  recoveryCode: string;
  logoUrl?: string;
  error: string;
  description?: string;
  onClickRecoveryCode: () => void;
  onChangeRecoveryCode: (event: React.ChangeEvent<HTMLInputElement>) => void;
}
const RecoveryCodeContainer = ({
  recoveryCode,
  logoUrl,
  error,
  description,
  onClickRecoveryCode,
  onChangeRecoveryCode
}: RecoveryCodeContainerProps) => {
  const theme = useTheme();

  return (
    <Box>
      <ClaimContainer
        image={logoUrl || Images.MOJITO_LOGO}
        title="New Device Detected"
        description="Please enter the recovery code emailed to when you first sign up."
      />
      <Typography
        sx={{
          marginBottom: '15px',
          textAlign: 'center',
          fontFamily: theme?.MojitoClaim?.font?.secondary
        }}
      >
        {description ?? 'The email title is Your recovery code to Mojito Wallet'}
      </Typography>
      <TextInput
        placeholder="Recovery code"
        InputPropsStyle={{
          height: '40px',
          color: theme?.palette?.common?.black
        }}
        sx={{
          width: '100%',
          marginBottom: '20px'
        }}
        value={recoveryCode}
        onChange={onChangeRecoveryCode}
        error={error}
      />
      <Button
        sx={{
          width: '100%',
          marginBottom: '15px'
        }}
        onClick={onClickRecoveryCode}
      >
        Continue
      </Button>
    </Box>
  );
};

export default RecoveryCodeContainer;
